exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fa-folder[data-v-34597724]{font-size:3em;color:#c3040d}.delete-folder[data-v-34597724]{position:absolute;top:-8px;right:0}.edit-folder[data-v-34597724]{position:absolute;top:30px;right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34597724","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/GeneralDocumentsFolderModal.vue
// module id = 6Ntc
// module chunks = 0